import React, { useState } from "react";
import Forwardcontract from "../Forwardcontract/Forwardcontract";
import LDDoc from "../sblcComponent/LDDoc";
import FormFooter from "../FormFooter/FormFooter";
import { useSelector } from "react-redux";
import html2pdf from "html2pdf.js";
import Images from "../../assets";
import moment from "moment";
import LDRollOver from "../sblcComponent/LDRollOver";
import ForwardcontractRollOver from "./ForwardContractRollOver";
import ForwardcontractConfirmation from "./ForwardContractConfirmation";

function SblcRollOverCom() {
  const [isProcessing, setIsProcessing] = useState(false);
  const retrievedData = useSelector((state) => state?.formdata);

  // Download logic

  const handleDownload = (elementId, filename) => {
    const element = document.getElementById(elementId);
    if (!element) return;

    setIsProcessing(true);
    const opt = {
      margin: 0,
      filename,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        scrollY: 0,
        windowWidth: document.documentElement.scrollWidth,
        windowHeight: document.documentElement.scrollHeight,
      },
      jsPDF: {
        unit: "mm",
        format: [210, 350],
        orientation: "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => setIsProcessing(false));
  };

  return (
    <>
      <div
        id="sblc_section_1"
        style={{
          width: "100%",
          maxWidth: "794px", // Limits to A4 width
          minHeight: "1123px",
          background: "white",
        }}
      >
        <div className="px-4 my-4">
          <div className="status-logo py-1">
            <img
              src={Images?.logo}
              alt="logo"
              style={{ height: "90%", width: "30%" }}
            />
            <p className="file-name-title">
              {retrievedData && retrievedData?.fileName}
            </p>
          </div>
          <div className="d-flex flex-column py-2">
            <div className="d-flex justify-content-between py-2">
              <p className="status-waiver-content">Letter No.</p>
              <p className="status-waiver-content">
                Date : {moment().format("DD.MM.YYYY")}
              </p>
            </div>
            <div className="d-flex flex-column  py-2">
              <p className="status-waiver-content">To</p>
              <p className="status-waiver-content">The Branch Manager</p>
              <p className="status-waiver-content">Branch : </p>
              <p className="status-waiver-content">The South Indian Bank Ltd</p>
            </div>

            <div className="d-flex flex-column  py-2">
              <p className="status-waiver-content">Sir/Madam</p>
              <p className="status-waiver-content">
                Sub: We request you to issue/rollover trade credit through stand
                by letter of credit on our behalf for the following outstanding
                import bill,
              </p>
            </div>
            <table className="sblc-table my-2">
              <tbody>
                <tr>
                  <td className="sblc-table-data">Bill Reference No:</td>
                  <td className="sblc-table-data">
                    {retrievedData?.bgNumber || "-"}
                  </td>
                </tr>
                <tr>
                  <td className="sblc-table-data">Drawer:</td>
                  <td className="sblc-table-data">
                    {/* FORWOOD INTERNATIONAL PTE LTD */}

                    {retrievedData?.rolloverType == "sameBg"
                      ? ""
                      : retrievedData && retrievedData?.foreignBankName}

                    {/* {retrievedData && retrievedData?.exporter
                      ? retrievedData && retrievedData?.exporter
                      : null} */}
                  </td>
                </tr>
                <tr>
                  <td className="sblc-table-data">Drawee:</td>
                  <td className="sblc-table-data">BEST TIMBERS</td>
                </tr>
                <tr>
                  <td className="sblc-table-data">Currency and Amount:</td>
                  <td className="sblc-table-data">
                    {" "}
                    USD
                    {retrievedData && retrievedData?.bgAmtAndInterestAmt
                      ? retrievedData && retrievedData?.bgAmtAndInterestAmt
                      : null}
                  </td>
                </tr>
                <tr>
                  <td className="sblc-table-data">Bill Due Date:</td>
                  <td className="sblc-table-data">
                    {/* {moment(retrievedData?.dueDate).format("DD/MM/YYYY")} */}
                  </td>
                </tr>
                <tr>
                  <td className="sblc-table-data">Tenor</td>
                  <td className="sblc-table-data">
                    {" "}
                    {retrievedData && retrievedData?.rolloverdays
                      ? retrievedData && retrievedData?.rolloverdays
                      : null}{" "}
                    Days
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="status-waiver-content  py-2">
              Please process the trade credit request and arrange to send your
              stand by letter of credit to
              <u>
                {/* UCO BANK, HONG KONG */}{" "}
                {retrievedData?.rolloverType == "sameBg"
                  ? retrievedData?.rolloverSameBgForeignBankName
                  : retrievedData?.rolloverNewBgForeignBankName}
                {/* {retrievedData && retrievedData?.foreignBankName
                  ? retrievedData && retrievedData?.foreignBankName
                  : null} */}
              </u>{" "}
              Bank and confirm.
            </p>
            <p className="status-waiver-content  py-2">
              We hereby agree with all the terms and conditions of stand by
              letter of credit which will be issued by you to the lending party
              on our behalf.
            </p>
            <p className="status-waiver-content  py-2">
              We confirm that we have not availed trade credit against above
              mentioned import transaction from any other bank or financial
              institution.
            </p>
            <p className="status-waiver-content  py-2">
              We also confirm that the period of trade credit is within our
              operating cycle.
            </p>
            <p className="status-waiver-content  py-2">
              We hereby authorize you to debit our following account number with
              you 0138084000000004 towards repayment of trade credit together
              with interest and other charges on maturity.
            </p>
            <p className="status-waiver-content  py-2">Thanking you,</p>
            <p className="status-waiver-content  mt-4 mb-2">BEST TIMBERS</p>
            {/* <img
              src={Images?.signIcon}
              alt="on-image"
              style={{ width: "100px", height: "40px" }}
            /> */}
            <p className="status-waiver-content mt-4">PARTNER</p>
            <p className="status-waiver-content mt-4">Encl: Form A1</p>
          </div>
          <footer>
            <FormFooter />
          </footer>
        </div>
      </div>
      <div className="d-flex justify-content-center py-4">
        <button
          className="summary-download-btn"
          onClick={() => handleDownload("sblc_section_1", "SBLC-RollOver.pdf")}
        >
          {isProcessing ? "Loading..." : "Download SBLC-RollOver"}
        </button>
      </div>
      {/* LDDOC */}
      <div
        id="sblc_section_2"
        style={{
          width: "100%",
          maxWidth: "794px", // Limits to A4 width
          minHeight: "1123px",
          background: "white",
        }}
      >
        <LDRollOver />
      </div>
      <div className="d-flex justify-content-center py-4">
        <button
          className="summary-download-btn py-2"
          onClick={() => handleDownload("sblc_section_2", "LD-RollOver.pdf")}
        >
          {isProcessing ? "Loading..." : "Download LD"}
        </button>
      </div>
      {/* FORWARD CONTRACT */}
      <ForwardcontractRollOver />
      {/* FORWARD CONTRACT CONFIRMATION */}
      <ForwardcontractConfirmation />
    </>
  );
}

export default SblcRollOverCom;
